var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.085 17.915c-.519 0-.92-.141-1.203-.424-.283-.307-.424-.72-.424-1.239v-5.801H1.762c-.495 0-.885-.13-1.168-.39C.311 9.778.17 9.39.17 8.894S.31 8.02.594 7.762c.283-.283.673-.425 1.168-.425h5.696V1.712c0-.519.141-.92.424-1.203.283-.283.696-.424 1.238-.424.52 0 .908.141 1.168.424.283.284.424.684.424 1.203v5.625h5.696c.519 0 .908.142 1.168.425.283.26.424.637.424 1.132 0 .495-.141.884-.424 1.167-.26.26-.649.39-1.168.39h-5.696v5.801c0 .52-.141.932-.424 1.239-.26.283-.66.424-1.203.424z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e4c4c5c5655edcccd0184234d4a42d08.svg";
export { ForwardRef as ReactComponent };